import { Component, OnInit, ViewChild, ChangeDetectorRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { SessionStorageService, SessionStorage } from "ngx-webstorage";
import { UtilService } from '../../components/common/utils/util.service';
import { SessionTokenService } from '../../components/common/utils/sessionToken.service';
import { HandleError } from '../../components/common/utils/handleError.component';
import { ClienteLogin, Cliente, ClienteXCiudad } from '../login/cliente_login';
import { UsuarioLoginEntity } from '../login/usuario_login_entity';
import { SiniestrosService } from './siniestros.service';
import { Siniestros, SiniestralidadSiniestros } from '../../components/common/siniestros_entity';

const swal = require("sweetalert2");

declare var jQuery: any;
@Component({
    selector: 'siniestralidad-siniestros',
    templateUrl: 'siniestralidad-siniestros.template.html'
})
export class SiniestralidadSiniestrosComponent implements OnInit {
    usuario: ClienteLogin;
    usuarioLogin: UsuarioLoginEntity;
    showLoader: string;
    userEmpresa: ClienteXCiudad;
    siniestralidad: SiniestralidadSiniestros[];
    totalPrima: number = 0;
    totalPendientes: number = 0;
    totalValorReserva: number = 0;
    totalCerrados: number = 0;
    totalValorIndemnizado: number = 0;
    totalSiniestralidad: number = 0;
    filterQuery: string;
    filterQuery1: string;
    ramos: string[];
    polizas: string[];

    constructor(
        private router: Router,
        private sessionTokenService: SessionTokenService,
        private handleError: HandleError,
        public sesionStorageService: SessionStorageService,
        public utilsService: UtilService,
        public siniestrosService: SiniestrosService) { 
            this.userEmpresa = new ClienteXCiudad();
            this.usuario = new ClienteLogin();
            this.siniestralidad = new Array<SiniestralidadSiniestros>();
            this.ramos = new Array<string>();
            this.filterQuery = "";
            this.filterQuery1 = "";
            this.polizas = new Array<string>();
        }
    ngOnInit() {
        try {
            this.showLoader = "sk-loading";
            this.usuario = jQuery.parseJSON(this.sesionStorageService.retrieve("usuario"));
            this.CargarDatos();

            this.sesionStorageService.observe("usuario").subscribe(a => {
                try {
                    this.usuario = jQuery.parseJSON(a);
                    this.CargarDatos();
                } catch (ex) {
                    this.usuario = a;
                    this.CargarDatos();
                }
            })
        } catch (ex) {

        }
    }
    CargarDatos(){
        if (this.usuario == null) {
            let error = { "status": 998, "message": "Acceso denegado" };
            this.handleError.redirectUrl(error)
        } else {
            let bandera = this.sessionTokenService.useJwtHelper();
            if (!bandera) {
                let cliente = new Cliente();
                try {
                    this.userEmpresa = jQuery.parseJSON(this.sesionStorageService.retrieve("usuarioEmpresa"));
                    cliente.Ciudad = this.userEmpresa.Ciudad;
                    cliente.CodigoCliente = this.userEmpresa.CodigoCliente;
                } catch (e) {
                    this.userEmpresa = this.sesionStorageService.retrieve("usuarioEmpresa");
                    cliente.Ciudad = this.userEmpresa.Ciudad;
                    cliente.CodigoCliente = this.userEmpresa.CodigoCliente;
                }
                this.consultarDatos(cliente);
            }
        }
    }

    consultarDatos(cliente: Cliente){
        this.siniestrosService.ConsultarSiniestralidadSiniestros(cliente).subscribe(
            result=>{
                this.siniestralidad = result;
                this.siniestralidad.forEach(a=>{
                    this.totalCerrados += a.Cerrados;
                    this.totalPendientes += a.Pendientes;
                    this.totalPrima += a.Produccion;
                    this.totalValorIndemnizado += a.ValorIndemnizado;
                    this.totalValorReserva += a.ValorReserva;
                    this.ramos.push(a.Ramo);
                    this.polizas.push(a.Poliza);
                });
                this.ramos = this.ramos.filter((x, i, a) => x && a.indexOf(x) === i);
                this.polizas = this.polizas.filter((x, i, a) => x && a.indexOf(x) === i);
                this.totalSiniestralidad = ((this.totalCerrados + this.totalPendientes)/this.totalPrima)/100;
                this.showLoader = "";
            },
            error=>{
                this.handleError.redirectUrl(error);
            }
        );
    }
}


// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/siniestros/siniestralidad-siniestros.component.ts